// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1315":"711ed76fc3ebe321","1979":"01905d89db1a1c4e","2849":"c37b00179cfc7c7a","6608":"cc90ecd85e24a233","7468":"b9ddf10c1fbc52bf","7902":"5cce0993f162b022","8413":"5b0e1b1d69df4718","9394":"34179e35b268d955"}[chunkId] + ".css";
};